import { Getters } from 'vuex-smart-module';
import CertificatesListState from './state';

export default class CertificatesListGetters extends Getters<CertificatesListState> {}
